<gl-base-modal [disableCloseButton]="true">
  <h2 class="title">{{ 'complete_profile_details_header' | translate }}</h2>
  <form [formGroup]="form" (ngSubmit)="onSubmit()" class="form">
    <div class="passwords">
      <p class="newLoginMethodInfo">{{ 'new_login_method_info' | translate }}</p>
      <gl-input-container [errorAboveInput]="true">
        <input
          type="password"
          placeholder="password_with_hint"
          normal-input
          formControlName="password"
        />
      </gl-input-container>
      <gl-input-container [errorAboveInput]="true">
        <input
          type="password"
          placeholder="repeat_password"
          normal-input
          formControlName="retypedPassword"
        />
      </gl-input-container>
    </div>
    <div class="buttons">
      <button normal-outline-button type="submit">{{ 'save' | translate }}</button>
    </div>
  </form>
</gl-base-modal>
